module.exports = __webpack_public_path__ + "img/1_5.d6212187.jpg";